<template>
  <div class="page-my-challenge">
    <ym-loadmore v-if="list.length > 0"
                 class="list"
                 v-model="loading"
                 :finished="allLoad"
                 @load="fetchData"
    >
      <div class="challenge-item"
           v-for="(item, index) in list"
           :key="index"
           @click="handleChallengeDetail(item.id)"
      >
        <div class="course-info">
          <h3 class="title ym-two-line-ellipsis">{{ item.title }}</h3>
          <div class="challenge-count">
            共{{ item.totalChallenge }}个挑战 | 已完成{{ item.finishChallenge }}个
          </div>
        </div>
        <div class="course-status">
          <span class="new-challenge"
                v-if="item.newChallenge"
          >
            有新挑战
          </span>
          <ym-icon class="icon"
                    name="right"
          />
        </div>
      </div>
    </ym-loadmore>
    <empty-page hint="暂无待完成挑战"
                v-if="allLoad && list.length === 0"
    />
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import EmptyPage from '@/components/EmptyPage';
  import { getChallengeCourseList } from '@/services/course';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageMyChallenge',
    metaInfo: {
      title: '待完成挑战',
    },
    components: {
      'ym-loadmore': Loadmore,
      EmptyPage,
    },
    data() {
      return {
        start: 0,
        list: [],
        loading: false,
        allLoad: false,
      };
    },
    methods: {
      async fetchData() {
        if (this.allLoad) return;
        this.loading = true;
        const data = await getChallengeCourseList({
          limit: LIMIT,
          start: this.start,
        });
        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.list = [...this.list, ...data.list];
        this.start = data.start;

        this.loading = false;
      },
      handleChallengeDetail(id) {
        this.$router.push({ name: 'ChallengeList', params: { id } });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-my-challenge {
    background: @color-white;
    height: 100%;
  }

  .list {
    padding: 0 @size-base;
    box-sizing: border-box;
    background: @color-white;
  }

  .challenge-item {
    padding: @size-base 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    &:after {
      position: absolute;
      content: '';
      width: 720px;
      height: 1px;
      background: @color-gray-lighter;
      left: 0;
      bottom: 0;
    }
  }

  .course-info {
    width: 448px;
  }

  .title {
    font-size: @font-size-medium;
    color: @color-text-base;
    font-weight: @font-weight-primary;
    line-height: 1.4;
    margin: 0 0 @size-small 0;
  }

  .challenge-count {
    color: @color-text-lighter;
    font-size: @font-size-small;
  }

  .course-status {
    color: @color-text-lighter;
    font-size: @font-size-base;
    .icon {
      color: @color-disabled;
    }
  }

  .new-challenge {
    position: relative;
    &:before {
      content: '';
      position: absolute;
      width: 12px;
      height: 12px;
      border-radius: 6px;
      background: @color-highlight;
      left: -@size-small;
      top: calc(50% - 6px);
    }
  }

</style>
